import React, { useCallback } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import useAuth from 'auth/UseAuth';
import { appSettings } from 'AppSettings';
import { BaseDownloadFile } from 'data/BaseData';
import { DownloadButton } from '../DownloadButton';

export function renderCellMultiQcDownloadButton(params: GridRenderCellParams) {
  if (params.value === undefined) {
    return <></>;
  }

  return <GridCellMultiQcDownloadButton sequenceRunId={params.value} />;
}

interface GridCellMultiQcDownloadButtonProps {
  sequenceRunId: string;
}

const GridCellMultiQcDownloadButton = ({ sequenceRunId }: GridCellMultiQcDownloadButtonProps) => {
  const { accessToken } = useAuth();

  const downloadData = useCallback(async () => {
    const url = `${appSettings.api.endpoint}/api/v2/Informatics/${sequenceRunId}`;
    await BaseDownloadFile(url, accessToken);
  }, [accessToken, sequenceRunId]);

  return (
    <DownloadButton
      downloadData={downloadData}
      sx={{
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }}
    />
  );
};
